var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    d.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      l.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, c(e));
import s, { forwardRef as n } from "react";
import w from "../lib/IconBase.mjs";
import F from "../defs/Folder.mjs";
const R = n((o, e) => /* @__PURE__ */ s.createElement(w, f(a({ ref: e }, o), { weights: F })));
R.displayName = "Folder";
export {
  R as Folder
};
